import { PropType } from 'vue';
import BaseSetupService from '@/setup/BaseSetupService';
import { Bus, itemIs, useAside, useNotif } from '@orion.ui/orion';
import UserProfileSpecificAvailabilitiesAsideNew from '@/components/user-profile/UserProfileSpecificAvailabilitiesAsideNew.vue';
import TempWorkerAvailabilityEntity from '@/entity/TempWorkerAvailabilityEntity';
import UnavailabilityApiTempWorker from '@/api/UnavailabilityApiTempWorker';
import SpecificAvailabilityApiTempworker from '@/api/SpecificAvailabilityApiTempWorker';


type Props = SetupProps<typeof DashboardTempWorkerAvailabilitiesSetupService.props>

export default class DashboardTempWorkerAvailabilitiesSetupService extends BaseSetupService<Props> {
	static readonly props = {
		type: {
			type: String as PropType<'availabilities' | 'unavailabilities' | 'specific'>,
			required: true as const,
		},
		value: {
			type: Number,
			default: undefined,
		},
		period: {
			type: Object as PropType<ISpecificAvailabilityModel | IUnavailabilityModel>,
			default: undefined,
		},
	};

	get title () {
		if (this.props.type === 'availabilities' || this.props.type === 'specific') return 'disponible';
		else return 'indisponible';
	}

	get morningColor () {
		if (this.props.value === 1 || this.props.value === 3 || this.props.value === 5 || this.props.value === 7) {
			return 'success';
		}
		return 'default';
	}

	get afternoonColor () {
		if (this.props.value === 2 || this.props.value === 3 || this.props.value === 6 || this.props.value === 7) {
			return 'success';
		}
		return 'default';
	}

	get nightColor () {
		if (this.props.value === 4 || this.props.value === 5 || this.props.value === 6 || this.props.value === 7) {
			return 'success';
		}
		return 'default';
	}

	get startDate () {
		if (this.props.period && itemIs<IUnavailabilityModel>(this.props.period, 'startDate'))
			return new Date(this.props.period.startDate);
	}

	get endDate () {
		if (this.props.period && itemIs<IUnavailabilityModel>(this.props.period, 'endDate'))
			return new Date(this.props.period.endDate);
	}

	get buttonStyle () {
		if (this.props.value === 1 || 2 || 4) return true;
		return false;
	}

	constructor (props?: Props) {
		super(props);
	}

	openAddSpecificAvailabilitiesAside () {
		if (this.props.period && itemIs<ISpecificAvailabilityModel>(this.props.period, 'monday'))
			useAside({
				Nested: UserProfileSpecificAvailabilitiesAsideNew,
				NestedProps: { availabilityEntity: new TempWorkerAvailabilityEntity(this.props.period) },
			});
	}

	async deleteUnavailabilityAsync () {
		if (!this.props.period) return;
		try {
			await UnavailabilityApiTempWorker.delete(this.props.period.id);
			useNotif.success(`La période d'indisponibilité a été supprimée`);
			Bus.emit(`DashboardTempWorkerCalendarSetupService:unvavailabilityDeleted`, this.props.period.id);
		} catch (e:any) {
			useNotif.danger(e.response.data);
		}
	}

	async deleteSpecificAvailabilityAsync () {
		if (!this.props.period) return;
		try {
			await SpecificAvailabilityApiTempworker.delete(this.props.period.id);
			useNotif.success(`La période a été supprimée`);
			Bus.emit(`DashboardTempWorkerCalendarSetupService:specificAvailabilityDeleted`, this.props.period.id);
		} catch (e:any) {
			useNotif.danger(e.response.data);
		}

	}
}
